import type { Account } from "modules/bank-accounts";
import type { Bank } from "modules/banks";
import type { PaymentProvider } from "modules/customers";
import type { Currency } from "../../../models/Currency";
import type { CurrencyCode } from "../../../models/CurrencyCode";
import type { Order } from "../../../models/helpers";
import type { PaymentNotification } from "../../../models/Notification";
import type { TransferType } from "../../../models/TransferType";
import type { UUID } from "../../../utils";
import type { PaymentBankResponses } from "./PaymentBankResponses";
import type { PaymentBeneficiary } from "./PaymentBeneficiary";
import type { PaymentInternationalClearing } from "./PaymentInternationalClearing";
import type { PaymentSender } from "./PaymentSender";
import type { PaymentStatus } from "./PaymentStatus";
import type PaymentStatusUpdate from "./PaymentStatusUpdate";
import type { PaymentTransaction } from "./PaymentTransaction";

export type IBAN = string;

export default interface Payment {
  id: UUID;
  account: Account;
  active: boolean;
  amount: number;
  createdAt: string;
  currency: Currency;
  isConnect: boolean;
  pblValidityPeriod: number | null;
  status: PaymentStatus;
  statusUpdates: PaymentStatusUpdate[];
  type: string;
  uniqueReference: string;
  bank?: Bank;
  bankResponses?: PaymentBankResponses;
  beneficiary?: PaymentBeneficiary;
  internationalClearing?: PaymentInternationalClearing;
  notifications?: PaymentNotification[];
  provider?: Pick<PaymentProvider, "id" | "name">;
  sender?: PaymentSender;
  transaction?: PaymentTransaction;
  transferType?: TransferType;
}

export const PROPERTY_BENEFICIARY_ACCOUNT_IDENTIFICATIONS =
  "beneficiary.accountIdentifications";
export const PROPERTY_BANK_RESPONSES = "bankResponses";
export const PROPERTY_PROVIDER = "provider";
export const PROPERTY_SENDER = "sender";
export const PROPERTY_SENDER_VOLT_CONNECT = "sender.voltConnect";
export const PROPERTY_SENDER_PAYMENT_PROVIDER = "sender.paymentProvider";
export const PROPERTY_SENDER_CHECKOUT = "sender.checkout";
export const PROPERTY_SENDER_ACCOUNT_NAME = "sender.accountName";

export type PaymentsQueryParams = {
  page: number;
  limit: number;
  orderBy: string;
  order: Order;
  query: string[];
  statuses: string[];
  startDate: string | null;
  endDate: string | null;
  minAmount: number | null;
  maxAmount: number | null;
  country: string | null;
  currency: CurrencyCode | null;
  customerId?: UUID | UUID[];
};
